
// Swiper ------------------------------------------------------

if (window.matchMedia( '(min-width: 569px)' ).matches) {
  const mySwiper = new Swiper('.swiper', {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    //ページネーション
    loop: true,
    centeredSlides: true,
    spaceBetween: 50,
    slidesPerView: 1.5,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true, // クリック有効化
    }
  });
}
else {
  const mySwiper = new Swiper('.swiper', {
    loop: true,
    centeredSlides: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    pagination: {
      el: ".swiper-pagination",
      clickable: true, // クリック有効化
    }
  });
}
